import { jsx as _jsx } from "react/jsx-runtime";
import { getLayouts } from './layout';
import TabelaBase from '../../library/TabelaBase';
export default function TabelaRetornosNominais(props) {
    const { titulo = 'Retornos Nominais da Carteira x Benchmarks', rows, layout, dadosMesAMesAgrupados, theme } = props;
    return (_jsx(TabelaBase, { rows: rows, layout: layout, titulo: titulo, layouts: getLayouts(dadosMesAMesAgrupados, theme), enhancedTableProps: {
            noScroll: true,
        } }));
}
